export default __webpack_public_path__ + "static/helix-bq-6-c3d4d9775f135b45eed0e9cbabf02989.jpg";